import { ENV_CONFIG } from './env';
import { systemConfig } from './system.config';

export const APP_CONFIG = {
  app: {
    name: 'Planning App',
    version: ENV_CONFIG.APP_VERSION,
    description: 'Inspections Auto Planning Application',
  },
  api: {
    baseUrl: systemConfig.apiUrl,
    timeout: 10 * 60 * 1000, // 10 minutes
  },
  auth: {
    tokenKey: 'planning_auth_token',
    userKey: 'planning_auth_user',
  },
  storage: {
    prefix: 'planning_app_',
  },
  logging: {
    enabled: ENV_CONFIG.IS_DEV,
    level: ENV_CONFIG.IS_DEV ? 'debug' : 'error',
  },
} as const;

